import { render, staticRenderFns } from "./LiveClassSetForm.vue?vue&type=template&id=3dd201bc&scoped=true"
import script from "./LiveClassSetForm.vue?vue&type=script&lang=js"
export * from "./LiveClassSetForm.vue?vue&type=script&lang=js"
import style0 from "./LiveClassSetForm.vue?vue&type=style&index=0&id=3dd201bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd201bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd201bc')) {
      api.createRecord('3dd201bc', component.options)
    } else {
      api.reload('3dd201bc', component.options)
    }
    module.hot.accept("./LiveClassSetForm.vue?vue&type=template&id=3dd201bc&scoped=true", function () {
      api.rerender('3dd201bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/liveClassSet/components/LiveClassSetForm.vue"
export default component.exports